import { type Configuration } from "./configuration";

export function isJinnyApp(config: Configuration): boolean {
  return config.appName === "EventJinny";
}

export function isMemoringApp(config: Configuration): boolean {
  return config.appName === "Memoring";
}

export function getContactEmail(config: Configuration): string {
  return isMemoringApp(config)
    ? "info@memoringphone.com"
    : "info@eventjinny.com";
}

const HEADER_LOGO_PATHS = {
  Memoring: "/assets/HeaderLogoMemoring.svg",
  EventJinny: "/assets/logo/EJ_logo_long_white.svg",
};

export function getHeaderLogoSource(config: Configuration): string | undefined {
  return HEADER_LOGO_PATHS[config.appName as keyof typeof HEADER_LOGO_PATHS];
}

export function getFavIconSource(config: Configuration): string {
  return isMemoringApp(config)
    ? "/assets/faviconMemoring.ico"
    : "/assets/faviconJinny.ico";
}

const HOME_LOGO_PATHS = {
  Memoring: "/assets/LogoMemoring.svg",
  EventJinny: "/assets/logo/EJ_logo_long_brown.svg",
};
export function getHomeLogoSource(config: Configuration): string | undefined {
  return HOME_LOGO_PATHS[config.appName as keyof typeof HOME_LOGO_PATHS];
}
